import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import injectSheet from 'react-jss';
import TotalMessages from "./TotalMessages";
import MessagesPerSecond from './MessagesPerSecond';
import BigIcon from "./BigIcon";
import {cdn} from '../helpers/cdn'
import Text from './Text';

const propTypes = {};

const componentMap = {
    totalMessages: {
        comp: <TotalMessages/>,
        title: "Total Messages",
        icon: cdn('icons/total-messages.svg'),
        background: '#52d3a9',
    },
    messagesPerSecond: {
        comp: <MessagesPerSecond/>,
        title: 'Messages per Second',
        icon: cdn('icons/messages-per.svg'),
        background: '#fdca00',
    }
};

const StatisticsBox = ({ type, classes }) => {
    const component = componentMap[type];
    return (
        <div className={`${classes.statsBox} ${[type]}`}>
           <BigIcon classes={classes.imgWrap} type={type} icon={component.icon} iconColor={component.background}/>
            <div className={classes.textWrapper}>
                <Text type="h3" classList={[classes.componentTitle]}>{component.title}</Text>
                <Text type="h2" classList={[classes.componentAmount]}>{component.comp}</Text>
            </div>
        </div>
    )
};

const styles = theme => ({
    statsBox: {
        display: 'flex',
        width: `calc(50% - ${theme.spacing / 2}px)`,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        borderRadius: theme.borderRadius,
        overflow: 'hidden',
        alignItems: 'center',
        backgroundColor: 'white',
        marginBottom: theme.spacing,
        boxShadow: theme.boxShadow,

        '&.totalMessages': {
            marginRight: theme.spacing / 2,
        },

        '&.messagesPerSecond': {
            marginLeft: theme.spacing / 2,
        },

        [theme.devices.small]: {
            width: '100%',
            maxWidth: theme.tables.small.maxWidth,
            '&.totalMessages, &.messagesPerSecond': {
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        }
    },
    textWrapper: {
        'padding-left': `${theme.spacing * 3.5}px`,
    },
    componentTitle: {
        marginTop: 3,
        marginBottom: 3
    },
    componentAmount: {
        marginBottom: 0,
        fontVariantNumeric: 'tabular-nums'
    }
});

StatisticsBox.propTypes = propTypes;


export default injectSheet(styles)(StatisticsBox);



// WEBPACK FOOTER //
// ./src/app/components/StatisticsBox.js